"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingShiftAssignment_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var Chair_1 = require("./Chair");
var SchedulingShiftType_1 = require("./SchedulingShiftType");
var SchedulingShiftAssignment_Factory = /** @class */ (function () {
    function SchedulingShiftAssignment_Factory() {
    }
    SchedulingShiftAssignment_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AssignedDate: Date_Factory_1.Date_Factory.CreateIncoming(model.AssignedDate),
            AssistantId: model.AssistantId,
            AssistantUser: User_1.User_Factory.CreateIncoming(model.AssistantUser),
            Chair: Chair_1.Chair_Factory.CreateIncoming(model.Chair),
            ChairId: model.ChairId,
            CreatedBy: model.CreatedBy,
            CreatedByUser: User_1.User_Factory.CreateIncoming(model.CreatedByUser),
            DoctorId: model.DoctorId,
            DoctorUser: User_1.User_Factory.CreateIncoming(model.DoctorUser),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchedulingShiftType: SchedulingShiftType_1.SchedulingShiftType_Factory.CreateIncoming(model.SchedulingShiftType),
            SchedulingShiftTypeId: model.SchedulingShiftTypeId,
        };
        return result;
    };
    SchedulingShiftAssignment_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AssignedDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.AssignedDate),
            AssistantId: model.AssistantId,
            AssistantUser: User_1.User_Factory.CreateOutgoing(model.AssistantUser),
            Chair: Chair_1.Chair_Factory.CreateOutgoing(model.Chair),
            ChairId: model.ChairId,
            CreatedBy: model.CreatedBy,
            CreatedByUser: User_1.User_Factory.CreateOutgoing(model.CreatedByUser),
            DoctorId: model.DoctorId,
            DoctorUser: User_1.User_Factory.CreateOutgoing(model.DoctorUser),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchedulingShiftType: SchedulingShiftType_1.SchedulingShiftType_Factory.CreateOutgoing(model.SchedulingShiftType),
            SchedulingShiftTypeId: model.SchedulingShiftTypeId,
        };
        return result;
    };
    return SchedulingShiftAssignment_Factory;
}());
exports.SchedulingShiftAssignment_Factory = SchedulingShiftAssignment_Factory;
